import { render, staticRenderFns } from "./FeatureImportance.vue?vue&type=template&id=300ca0af&"
import script from "./FeatureImportance.vue?vue&type=script&lang=js&"
export * from "./FeatureImportance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports